import { type WorkoutItemGroupType } from "api-client/legacy-trpc";

import { type GroupWorkoutItemData } from "src/workouts/WorkoutEditStore";

import { InstructionsField } from "./InstructionsField";
import { SectionFieldsContainer } from "./SectionFieldsContainer";
import { SectionTypeField } from "./SectionTypeField";

interface RegularSectionFieldsProps {
  workoutItem: GroupWorkoutItemData;
  onUpdate: (updates: Partial<GroupWorkoutItemData>) => void;
}

export function RegularSectionFields(props: RegularSectionFieldsProps) {
  function handleStopPropagation(e: React.MouseEvent) {
    e.stopPropagation();
  }

  return (
    <SectionFieldsContainer onClick={handleStopPropagation}>
      <SectionTypeField
        value={props.workoutItem.groupType}
        onChange={(value: WorkoutItemGroupType) => {
          props.onUpdate({ groupType: value });
        }}
      />
      <InstructionsField
        value={props.workoutItem.instructions}
        onChange={(value) => {
          props.onUpdate({ instructions: value });
        }}
      />
    </SectionFieldsContainer>
  );
}
